import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { NgIf } from "@angular/common";
import { TranslateModule } from '@ngx-translate/core';
import { TalentHappyPathAuthService } from "../../service/talent-happy-path-auth.service";
import { Countries } from "../../../../enums";

@Component({
    selector: 'app-logout-confirmation-modal',
    imports: [
        TranslateModule
    ],
    templateUrl: './logout-confirmation-modal.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./logout-confirmation-modal.component.scss']
})

export class LogoutConfirmationModalComponent implements OnChanges {

  aquentUrl: string = "https://aquent.com";
  @Input() countryId: number;

  @Output() cancel = new EventEmitter<void>();
  @Output() yes = new EventEmitter<void>();

  constructor(private authService: TalentHappyPathAuthService) {}

  ngOnChanges(changes: SimpleChanges) {
    this.aquentUrl = this.getAquentUrl(this.countryId);
  }

  onCancel() {
    this.cancel.emit();
  }

  logout(){
    this.authService.clear();
  }

  getAquentUrl(id: number): string {
    if (id) {
      switch (id) {
        case Countries.UK:
          return "https://aquent.co.uk";
        case Countries.FR:
          return "https://aquent.fr";
        case Countries.DE:
          return "https://aquent.de";
        case Countries.JP:
          return "https://aquent.co.jp";
        case Countries.AU:
          return "https://aquent.com.au";
        case Countries.NL:
          return "https://aquent.nl";
        default:
          return "https://aquent.com";
      }
    }
  }

}
